<template>
    <modal
        headline="Aktionen"
        :value="true"
        @input="$emit('input', $event)"
    >
        <p v-if="description" class="mb-24" v-html="description" />

        <div v-if="tags.length" class="u-flex u-flex-wrap mb-6">
            <div v-for="(tag, i) in tags" :key="`tag-${i}`" class="tag mb-12 mr-6">{{ tag }}</div>
        </div>

        <ul class="u-reset-list">
            <li v-if="!persistDelete">
                <app-button class="u-full-width mb-12" theme="default" @click.native="$emit('edit')">Bearbeiten</app-button>
            </li>
            <li v-if="showArchive">
                <app-button class="u-full-width mb-12" theme="primary" @click.native="$emit('archive')">Archivieren</app-button>
            </li>
            <li>
                <app-button class="u-full-width" theme="highlight" @click.native="$emit('delete')">
                    {{ persistDelete ? 'Endgültig löschen' : 'In Papierkorb verschieben' }}
                </app-button>
            </li>
        </ul>
    </modal>
</template>

<script>
import AppButton from '@/components/ui/Button.vue'
import Modal from '@/components/ui/Modal.vue'

export default {
    name: 'DocumentActionModal',

    components: { AppButton, Modal },

    props: {
        description: { type: String, default: '' },
        tags: { type: Array, default: () => [] },
        persistDelete: { type: Boolean, default: false },
        showArchive: { type: Boolean, default: false },
    },
}
</script>

<style lang="scss" scoped>
.tag {
    background: $primary-color;
    color: $white;
    padding: $spacing-unit-6;
    border-bottom: 2px solid lighten($primary-color, 30%);
}
</style>
